import { render, staticRenderFns } from "./ViewAllCertificatesProfile.vue?vue&type=template&id=8db6aedc&scoped=true&"
import script from "./ViewAllCertificatesProfile.vue?vue&type=script&lang=js&"
export * from "./ViewAllCertificatesProfile.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllCertificatesProfile.vue?vue&type=style&index=0&id=8db6aedc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db6aedc",
  null
  
)

export default component.exports